import { mapTokenToSession, mapUserToToken } from "@repo/lib/helpers";
import {
  authorizeRegister,
  authorizeSocialLogin,
  authorizeWithOTP,
  authorizeWithPassword,
} from "@repo/server-actions/account";
import NextAuth from "next-auth";
import Credentials from "next-auth/providers/credentials";
import GoogleProvider from "next-auth/providers/google";

export const { handlers, auth, signIn, signOut } = NextAuth({
  providers: [
    Credentials({
      name: "Credentials",
      credentials: {
        username: {},
        password: {},
        email: {},
        otp: {},
        fromRegister: {},
      },
      async authorize(credentials) {
        if (credentials.fromRegister === "true") {
          const { fromRegister, locale, ...rest } = credentials;
          return authorizeRegister({ ...rest });
        }
        if (credentials.username && credentials.password) {
          return authorizeWithPassword(credentials); // Authorize with username and password
        } else if (credentials.email && credentials.otp) {
          return authorizeWithOTP(credentials); // Authorize with email and OTP
        }
        throw new Error("Missing or invalid login credentials");
      },
    }),
    // Google provider
    GoogleProvider({
      clientId: process.env.GOOGLE_CLIENT_ID,
      clientSecret: process.env.GOOGLE_CLIENT_SECRET,
    }),
  ],
  secret: process.env.AUTH_SECRET,
  pages: {
    signIn: "/login",
  },
  callbacks: {
    async signIn({ account, profile }) {
      // Handle Google login → call backend socialLogin
      if (account?.provider === "google" && profile) {
        try {
          const response = await authorizeSocialLogin({
            email: profile.email,
            socialId: profile.sub, // Google unique ID
            socialType: "google",
            name: profile.name,
          });

          if (response?.success) {
            account.backendResponse = response;
            return true;
          }
          const errorMessage = response?.message || "Social login failed";
          return `/login?error=social&message=${encodeURIComponent(errorMessage)}`;
        } catch (err) {
          return `/login?error=social&message=${encodeURIComponent(err.message)}`;
        }
      }
      return true;
    },
    async jwt({ token, user, trigger, session, account }) {
      // if there is social-login
      if (account?.provider === "google" && account.backendResponse) {
        return { ...token, ...mapUserToToken(account.backendResponse) };
      }
      // If user is available, map user data to token
      if (user) return { ...token, ...mapUserToToken(user) };
      // Code to run after triggering update from client side
      if (trigger === "update" && session) {
        token = { ...token, ...session.user };
        return token;
      }

      return token;
    },
    async session({ session, token }) {
      // Pass the user's data to the session object
      return mapTokenToSession(session, token);
    },
  },
  // TODO: remove this after testing
  //trustHost: process.env.AUTH_URL === "true",
  /* trustHost:
    process.env.NODE_ENV === "production" ? process.env.AUTH_URL : true, */
});
